module.exports = "<div class=\"ngx-page-refresh\">\n\t<button mat-icon-button color=\"primary\" (click)=\"onRefreshPage()\"><i class=\"fa fa-refresh\"></i></button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/shared/ngxGrid/ngxRefresh.component.html
// module id = ../../../../../src/app/shared/ngxGrid/ngxRefresh.component.html
// module chunks = main